import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Container, Typography, Link } from '@mui/material';
import BrandName from '../BrandName';
import { DEMO_REQUEST_EMAIL, DEMO_REQUEST_MAILTO, DESIGN_PARTNER_MAILTO, INTEREST_LIST_MAILTO } from '../../config/contact';
import { marketingFooterLinkSx } from './marketingSystem';

const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: { xs: 5, md: 6 },
        backgroundColor: '#10264d',
        color: 'white',
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: '1.3fr 0.9fr 0.8fr' },
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', md: 'flex-start' },
            gap: 4,
          }}
        >
          <Box>
            <BrandName color="white" useImage={true} logoVariant="wordmark" height={{ xs: 32, md: 36 }} />
            <Typography
              sx={{
                mt: 1.5,
                maxWidth: 320,
                color: 'rgba(255,255,255,0.68)',
                lineHeight: 1.6,
                fontSize: '0.88rem',
              }}
            >
              Processor-agnostic AI payment optimization that works inside the stack you already run.
            </Typography>
          </Box>
          <Box>
            <Typography sx={{ fontWeight: 400, mb: 1.5, fontSize: '0.95rem' }}>
              Explore
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
              <Link component={RouterLink} to="/how-it-works" sx={marketingFooterLinkSx}>
                Platform
              </Link>
              <Link component={RouterLink} to="/solution" sx={marketingFooterLinkSx}>
                Solutions
              </Link>
              <Link component={RouterLink} to="/resources" sx={marketingFooterLinkSx}>
                Insights
              </Link>
              <Link component={RouterLink} to="/case-studies" sx={marketingFooterLinkSx}>
                Case studies
              </Link>
              <Link component={RouterLink} to="/white-papers" sx={marketingFooterLinkSx}>
                White papers
              </Link>
              <Link component={RouterLink} to="/about" sx={marketingFooterLinkSx}>
                About
              </Link>
            </Box>
          </Box>
          <Box>
            <Typography sx={{ fontWeight: 400, mb: 1.5, fontSize: '0.95rem' }}>
              Get in touch
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
              <Link href={DEMO_REQUEST_MAILTO} sx={marketingFooterLinkSx}>
                Request demo
              </Link>
              <Link href={INTEREST_LIST_MAILTO} sx={marketingFooterLinkSx}>
                Join interest list
              </Link>
              <Link href={DESIGN_PARTNER_MAILTO} sx={marketingFooterLinkSx}>
                Become a design partner
              </Link>
              <Typography sx={{ color: 'rgba(255,255,255,0.68)', fontSize: '0.88rem', lineHeight: 1.6 }}>
                {DEMO_REQUEST_EMAIL}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Typography
          sx={{
            mt: 4,
            pt: 2.5,
            borderTop: '1px solid rgba(255,255,255,0.14)',
            fontSize: '0.8rem',
            color: 'rgba(255,255,255,0.6)',
            textAlign: { xs: 'left', md: 'center' },
          }}
        >
          © {new Date().getFullYear()} Ormal. All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
